import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import {default as PaymentsPage} from "../modules/AutomatedPayments/AutomatedPaymentsPage";

export function AutomatedPaymentsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "automatedPayments-page-title",
    defaultMessage: "Automated pages"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <PaymentsPage/>;
}
